module.exports = __webpack_public_path__ + "assets/cfe8558d141cf643a008fb4a145f1aad.mp4";